import { Box } from "@kolmeo/ui-core";
import { Dimensions } from "react-native";

const TooltipContentWrapper = ({ children, width }: { width?: number } & React.PropsWithChildren) => (
  <Box maxWidth={width ?? Dimensions.get("window").width / 2}>{children}</Box>
);

export default TooltipContentWrapper;
